module.exports = __webpack_public_path__ + "static/img/logo_white.36cbc6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/logo_white.png
// module id = U3kY
// module chunks = 0